export default {
  map_view: { id: 'map_view' },
  satellite: { id: 'satellite' },
  user_list: { id: 'user_list' },
  locus_list: { id: 'locus_list' },
  user_profile: { id: 'user_profile' },
  site_list: { id: 'site_list' },
  licensees: { id: 'licensees' },
  mortality: { id: 'mortality' },
  environment: { id: 'environment' },
  growth: { id: 'growth' },
  site_modules: { id: 'site_modules' },
  digital_logbook: { id: 'digital_logbook' },
  data_entry_check: { id: 'data_entry_check' },
  weight: { id: 'weight' },
  sea_lice: { id: 'sea_lice' },
  comments: { id: 'comments' },
  entry: { id: 'entry' },
  view: { id: 'view' },
  analytics: { id: 'analytics' },
  survival: { id: 'survival' },
  disease: { id: 'disease' },
  newEntry: { id: 'new_entry' },
  history: { id: 'log_history' },
  dashboard: { id: 'dashboard' },
  settings: { id: 'settings' },
  home: { id: 'home' },
  feed: { id: 'feed' },
  health: { id: 'health' },
  my_logs: { id: 'my_logs' },
  apps: { id: 'apps' },
  slaMonitor: { id: 'sla_monitor' },
  environmentMonitor: { id: 'environment_monitor' },
  logbook: { id: 'logbook' },
  salesDashboard: { id: 'sales_dashboard' },
  sensorsMonitor: { id: 'sensors_monitor' },
  ectoMaps: { id: 'ecto_maps' },
  ectoDashboards: { id: 'ecto_dashboards' },
  ectoSatellites: { id: 'ecto_satellites' },
  monitorsAndAlerts: { id: 'monitors_and_alerts' },
  dailyLogbookEvents: { id: 'daily_logbook_events' },
  dailyLogbookStatus: { id: 'daily_logbook_status' },
  dataBrowser: { id: 'data_browser' },
  logbookForms: { id: 'logbook_forms' },
  seawaterMortality: { id: 'seawater_mortality' },
  ovaMortality: { id: 'ova_mortality' },
  biomassSensors: { id: 'biomass_sensors' },
  transferPerformance: { id: 'transfer_performance' },
  mySeawaterSites: { id: 'my_seawater_sites' },
  weather: { id: 'weather' },
  mortalityForecast: { id: 'mortality_forecast' },
  samplingDistributionAndFrequency: {
    id: 'sampling_distribution_and_frequency',
  },
  stocking: { id: 'stocking' },
  lotTraceability: { id: 'lot_traceability' },
  freshwaterProduction: { id: 'freshwater_production' },
  logout: { id: 'logout' },
  profile: { id: 'profile' },
  application: { id: 'application' },
  licensee_application: { id: 'licensee_application' },
  translations: { id: 'translations' },
  sisense: { id: 'sisense_dashboard' },
  site_group_list: { id: 'site_group_list' },
  audit: { id: 'audit' },
  unit_group_list: { id: 'unit_group_list' },
  user_group_list: { id: 'user_group_list' },
  company_name: { id: 'company_name' },
  leaveFeedback: { id: 'leave_feedback' },
  anonymous: { id: 'anonymous' },
  appsStore: { id: 'apps_store' },
  jobs: { id: 'jobs' },
  personalInfo: { id: 'personal_info' },
  notifications: { id: 'notifications' },
  featureFlags: { id: 'feature_flags' },
}
